// Homepage Cover Animation
var animation_lenght = Object.keys(animationlist).length;
let container=[];
let animation=[];
let animationCompleted=[];
for (let i = 0; i < animation_lenght; i++) {
  var animation_values = animationlist[i].split(',');
  container[i] = document.getElementById(animation_values[0]);
  animationCompleted[i]=true;

  if(container[i]!=undefined){
    animation[i] =lottie.loadAnimation({
      container: container[i],
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: ''+animation_values[1]+''
    });
    animation[i].addEventListener("complete", () => {
      animationCompleted[i] = true;
     });
    container[i].addEventListener("click", () => {
      if (animationCompleted[i]) {
        animation[i].goToAndPlay(0, true);    
        animationCompleted[i] = false;
      }
    });
   
  }
}

 window.onscroll = function() {
  for (let i = 0; i < animation_lenght; i++) {
      if (animationCompleted[i]) {
        animation[i].goToAndPlay(0, true);    
        animationCompleted[i] = false;
      }
  }
}

//Homepage Cover Animation END
